<template>
  <div>
    <b-card>
      <b-row
        v-for="car in carList"
        :key="car.CODE"
        :id="car.CODE"
        class="card-text mt-2">
        <b-col>
          <b-row>
            <b-col md="4">
              <b-btn
                :class="[car.COLLAPSED ? null : 'collapsed']"
                :aria-controls="car.CODE"
                :aria-expanded="car.COLLAPSED ? 'true' : 'false'"
                size="sm"
                @click="toggleCollapse(car.CODE)">
                <i :class="[car.COLLAPSED ? 'icon-minus' : 'icon-plus']"/>
              </b-btn>
              {{ car.CAR_DETAIL.NAME }}
            </b-col>
            <b-col md="2">
              {{ car.CAR_DETAIL.LICENSE_PLATE }}
            </b-col>
            <b-col md="2">
              {{ car.CAR_DETAIL.MILEAGE + 'km' }}
            </b-col>
          </b-row>
          <b-collapse
            :id="car.CODE"
            v-model="car.COLLAPSED">
            <b-card class="mt-2">
              <span
                v-if="!car.LOGS.length"
                class="text-danger">This car doesn't have any logs.</span>

              <b-tabs
                v-if="car.LOGS.length"
                class="mt-2">
                <b-tab
                  v-for="(log, index) in car.LOGS"
                  :title="getTitle(index+1)"
                  :key="log.CODE"
                  :active="index === 0">
                  <b-row>
                    <b-col md="4">
                      <span class="font-weight-bold">Status:&nbsp;</span>
                      <span
                        :class="{'badge-success': log.STATUS > 0, 'badge-danger': log.STATUS < 1}"
                        class="badge">
                        {{ log.STATUS > 0 ? 'Reviewed' : 'Unreviewed' }}
                      </span>
                      <br >
                      <span class="font-weight-bold">Assigned Cleaner:&nbsp;</span>
                      <span>{{ getCleanerName(log.USER_ACCOUNT_CODE) }}</span>
                      <br >
                      <span class="font-weight-bold">Cleaning Date:&nbsp;</span>
                      <span>{{ log.LOG_DATE }}</span>
                    </b-col>
                    <b-col md="4">
                      <span class="font-weight-bold">Rating:&nbsp;</span>
                      <star-rating
                        v-model="log.CLEANING_RATE_RATING"
                        :star-size="16"
                        :show-rating="false"
                        :read-only="log.STATUS > 0"
                        class="align-top"
                        inline
                        @rating-selected="updateRating(log)"/>
                      <br >
                      <span class="font-weight-bold">Rating Date:&nbsp;</span>
                      <span>{{ log.CLEANING_RATE_DATE }}</span>
                    </b-col>
                    <b-col md="4">
                      <div class="w-25">
                        <b-img
                          v-if="car.COLLAPSED"
                          :src="log.PIC_URL"
                          fluid
                          style="cursor: pointer; width: 50"
                          @click="openImgModal(log)"/>
                      </div>
                    </b-col>
                  </b-row>
                </b-tab>
              </b-tabs>

            </b-card>
          </b-collapse>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<script>
import StarRating from 'vue-star-rating'
import moment from 'moment'
import { toastr, server } from '@/services/'
import { ImageModal } from '@/components/modals'

export default {
  name: 'CarsView',
  components: {
    StarRating
  },
  props: {
    cars: {
      type: Array,
      default: () => []
    },
    carInStations: {
      type: Array,
      default: () => []
    },
    carLogs: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      carList: this.cars,
      logs: this.carLogs
    }
  },
  methods: {
    getTitle (idx) {
      let s = ["th","st","nd","rd"]
      let v = idx % 100;
      return idx+(s[(v-20)%10]||s[v]||s[0]) + ' wash';
    },
    getCleanerName(accountCode) {
      let cleaner = this.$store.getters['cleaningLogs/getCleanerByCode'](accountCode)
      if (!cleaner) {
        return 'N/A'
      }
      return `${cleaner.USER_PROFILE_FIRST_NAME} ${cleaner.USER_PROFILE_LAST_NAME}`
    },
    logsByCar (code) {
      return this.logs.filter(log => log.CAR_IN_STATION_CODE === code)
    },
    toggleCollapse (cistCode) {
      this.$store.commit('cleaningLogs/toggleCar', cistCode)
    },
    updateRating (log) {
      let today = moment().format('YYYY-MM-DD')
      log.CLEANING_RATE_DATE = today
      let payload = {
        ratingNum: log.CLEANING_RATE_RATING,
        carInStationCode: log.CAR_IN_STATION_CODE,
        cleaningDate: log.LOG_DATE,
        userAccountCode: log.USER_ACCOUNT_CODE
      }
      server.post('/ops/updateCleaningLogs', [payload]).then(
        () => {
          toastr.success()
        },
        () => toastr.serverError()
      )
    },
    openImgModal (log) {
      this.$modal.show(ImageModal, {image: log.PIC_URL} ,{height: 'auto', scrollable: true})
    }
  }
}
</script>
